import React from 'react';
import { MDText } from 'i18n-react';

import Strapline from 'Components/StaticPages/ProductPageComponents/Strapline/Strapline';

import LocalTexts from '../DiscoverMWPay.texts.json';

const LocalT = new MDText(LocalTexts);

export const StraplineSection: React.FC = () => (
	<Strapline
		stats={LocalTexts.strapline.stats.map((stat) => ({
			primary: `${LocalT.translate(stat.primary)}`,
			secondary: `${LocalT.translate(stat.secondary)}`,
		}))}
	/>
);
